import { render, staticRenderFns } from "./OnboardingDashboardInfos.vue?vue&type=template&id=09e30917&scoped=true&"
import script from "./OnboardingDashboardInfos.vue?vue&type=script&lang=js&"
export * from "./OnboardingDashboardInfos.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDashboardInfos.vue?vue&type=style&index=0&id=09e30917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e30917",
  null
  
)

export default component.exports